import Unique from 'app/services/Unique';
import React, { useContext } from 'react';

const UniqueIdRootContext = React.createContext<Unique | undefined>(undefined);

export const useUniqueIdRoot = () => useContext(UniqueIdRootContext);

export const GetUniqueIdRoot = UniqueIdRootContext.Consumer;
export const UniqueIdProvider = ({ service, children }: { service: Unique, children: React.ReactNode }) => (
  <GetUniqueIdRoot>{(existing) => (
    !existing
    ? (
      <UniqueIdRootContext.Provider value={service}>
        {children}
      </UniqueIdRootContext.Provider>
    )
    : children
  )}</GetUniqueIdRoot>
);
